export function uniqBy(key, items) {
  return [...new Map(items.map(item => [item[key], item])).values()];
}